import React from 'react';
import { LeftNavbarContainer } from './styles';
import { MenuItem, NavbarContainerItems } from '../../styles';

import CloseButton from '../../../../../Components/Reutilizaveis/CloseButton';
import { ReactComponent as ExitIcon } from '../../../../../assets/novosicones/Sindico/exit_to_app.svg';
const LeftNavbar = ({
  isOpen,
  close,
  goToHome,
  goToSolicitations,
  goToDocuments,
  handleLogoutSindico,
  activeRoute,
}) => {
  return (
    isOpen && (
      <LeftNavbarContainer>
        <CloseButton tamanho={24} onClick={close} />
        <NavbarContainerItems dir='column'>
          <MenuItem
            onClick={goToHome}
            isActive={activeRoute === '/sindico/inicio/'}
          >
            INÍCIO
          </MenuItem>
          <MenuItem
            onClick={goToSolicitations}
            isActive={activeRoute === '/sindico/solicitacoes-abertas/'}
          >
            SOLICITAÇÕES
          </MenuItem>
          <MenuItem
            onClick={goToDocuments}
            isActive={activeRoute === '/sindico/documentos/'}
          >
            DOCUMENTOS
          </MenuItem>
          <MenuItem onClick={handleLogoutSindico} className='icon-exit-sindico'>
            SAIR <ExitIcon />
          </MenuItem>
        </NavbarContainerItems>
      </LeftNavbarContainer>
    )
  );
};

export default LeftNavbar;
